module.exports = __webpack_public_path__ + "img/营收系统.b262b445.jpg";